export default __webpack_public_path__ + "static/media/3_google_tag_manager.888c0632.svg";